import { render, staticRenderFns } from "./TourBike.vue?vue&type=template&id=43c5fad0&"
import script from "./TourBike.vue?vue&type=script&lang=js&"
export * from "./TourBike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourBike.vue"
export default component.exports